<template>
    <div class="flex text-sm p-4">
        <div class="w-3/5 p-2">
            {{ item.description.en }}

            <p class="mt-2 text-sm text-green">{{ item.indicator }}</p>

            <div class="pt-2 text-grey" >
                Unit: {{ item.unit }}
            </div>
        </div>

        <div class="w-2/5 flex">
            <div class="w-3/5 p-2 flex">
                <div class="">
                    <span class="text-xs text-grey uppercase tracking-wide">Range</span><br/>
                    {{ item.begin | limit }} - {{ item.end | limit }}
                </div>
            </div>

            <div class="w-2/5 p-2">
                <span class="text-xs text-grey uppercase tracking-wide">Correlation</span><br/>
                <span class="text-xl pl-2 pt-2">{{ item.r | format_r }}</span>
            </div>
        </div>

    </div>
</template>

<script>
    export default {

        props: ['item'],

        filters: {
            limit: function (value) {
                return value.substring(0, 4);
            },
            format_r: function (value) {
                if (value === 1) {
                    return "1.00";
                }

                if (value === null) {
                    return "0.00";
                }

                return value.toString().substring(0, 4);
            }
        },

    }
</script>